import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useRef, useEffect } from 'react';

/**
 * Ensures date picker inputs keep their value when the user edits
 * but clears when the value is cleared externally
 */
var usePickerInputValue = function usePickerInputValue(value) {
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var changed = useRef(false);
  useEffect(function () {
    // keep the input value if there's no longer a value and the input was just changed
    var keepInputValue = !value && changed.current;
    if (!keepInputValue) setInputValue(null);
    changed.current = false;
  }, [value]);
  return [inputValue !== null && inputValue !== void 0 ? inputValue : value, function (v) {
    changed.current = true;
    setInputValue(v);
  }];
};

var usePickerInputValue$1 = usePickerInputValue;

export { usePickerInputValue$1 as default };
